import {
  GROUP_BY_PLAYER,
  TABLE_TRACKING,
  TRACKS_FILTER_INTERVAL,
  TRACKS_FILTER_OUTFIT,
  TRACKS_GROUP,
  TRACKS_HIDE,
  TRACKS_REVIEW,
  TRACKS_SEARCH,
  TRACKS_FILTER_TEAM,
} from '@/constants';

export const getDefaultState = () => {
  return {
    canonicalPoints: {},
    filters: {
      [TRACKS_GROUP]: GROUP_BY_PLAYER,
      [TRACKS_HIDE]: [],
      [TRACKS_FILTER_INTERVAL]: '',
      [TRACKS_FILTER_OUTFIT]: '',
      [TRACKS_REVIEW]: true,
      [TRACKS_SEARCH]: '',
      [TRACKS_FILTER_TEAM]: null,
    },
    items: [],
    defaultSort: {
      page: 1,
      column: 'team_id',
      order: 'ascending',
      limit: 0,
    },
    jerseysOverview: {},
    sort: {
      page: 1,
      column: 'team_id',
      order: 'descending',
      limit: 0,
    },
    more: true,
    loading: false,
    total: 0,
    modal: {
      type: '',
      details: {},
    },
    tableMode: TABLE_TRACKING,
  }
};

export default getDefaultState();
